module.exports = __webpack_public_path__ + "static/media/user.99e6ad60.png";